<template>
<div class="block-add-brand-wrap">
  <el-dialog :title="`${TYPESTR[type]}品牌`" :close-on-click-modal="false" :visible.sync="dialogFormVisible" :before-close="hanlderClose">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item label="品牌名称：" :label-width="formLabelWidth" prop="brandName">
        <el-input v-model="form.brandName" autocomplete="off" class="block-input" maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="经营模式：" :label-width="formLabelWidth" prop="businessModeList">
        <el-checkbox-group v-model="form.businessModeList">
          <el-checkbox :label="0">直营</el-checkbox>
          <el-checkbox :label="1">加盟</el-checkbox>
          <el-checkbox :label="2">联营</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="品牌介绍：" :label-width="formLabelWidth"  prop="brandIntroduction">
        <el-input v-model="form.brandIntroduction" type="textarea" autocomplete="off"  class="block-input" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="品牌LOGO：" :label-width="formLabelWidth"  prop="brandLogoUrl">
        <div class="block-upload">
          <img v-if="form.brandLogoUrl" :src="form.brandLogoUrl" class="avatar" @click="hanlderUploadClick">
          <i v-else class="el-icon-plus avatar-uploader-icon flex-row-center" @click="hanlderUploadClick"></i>
          <input type="file" style="display:none" @change="handleUpload" id="uploadPic" />
        </div>
      </el-form-item>

      <el-form-item label="启用状态：" :label-width="formLabelWidth" prop="brandStatus">
        <el-switch
          v-model="form.brandStatus">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hanlderClose">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getBrandDetail, addBrand, modifyBrand, uploadPic } from '@/api/merchant-info'
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    value: {
      type: Boolean,
      default: false
    },
    rowInfo: {
      type: Object
    }
  },
  computed: {
    dialogFormVisible: {
      get () {
        return this.value
      },
      set () {}
    }
  },
  data () {
    return {
      TYPESTR: {
        1: '新增',
        2: '编辑'
      },
      imageUrl: '',
      formLabelWidth: '120px',
      radio: '1',
      value1: true,
      form: {
        brandName: '',
        businessModeList: [],
        brandIntroduction: '',
        brandLogoUrl: '',
        brandStatus: true
      },
      rules: {
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' }
        ],
        businessModeList: [
          { required: true, message: '请选择经营模式', trigger: 'change' }
        ],
        brandIntroduction: [
          { required: true, message: '请输入品牌介绍', trigger: 'blur' }
        ],
        brandLogoUrl: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      },
      loading: ''
    }
  },
  created () {
    if (this.type === 2) {
      this.BrandDetail()
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          return false
        }
      })
    },
    /**
    * @desc 上传照片
    */
    async handleUpload (e) {
      try {
        const formData = new FormData()
        formData.append('file', e.target.files[0])
        formData.append('ruleId', this.form.id)
        formData.append('ruleType', this.form.ruleType)
        const res = await uploadPic(formData)
        this.form.brandLogoUrl = res.data
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * @description: 品牌详情
     * @return {*}
     */
    async BrandDetail () {
      try {
        const res = await getBrandDetail({
          id: this.rowInfo.id
        })
        if (res.error_code === '0') {
          this.form = res.data
          this.form.brandStatus = this.form.brandStatus === 1
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 新增编辑品牌
    async submit () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let res
      try {
        const prams = { ...this.form }
        prams.brandStatus = prams.brandStatus ? 1 : 0
        if (this.type === 1) {
          res = await addBrand(prams)
        }
        if (this.type === 2) {
          res = await modifyBrand(prams)
        }
        if (res.error_code === '0') {
          this.$message.success(`${this.TYPESTR[this.type]}成功`)
          this.$emit('hanlderSuccessBrand')
          this.hanlderClose()
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    },
    hanlderUploadClick () {
      document.getElementById('uploadPic').click()
    },
    hanlderClose () {
      this.$emit('hanlderClose')
    }
  }
}
</script>

<style lang="scss" scoped>
.block-input{
  width:240px;
}
.avatar-uploader-icon{
  display:flex;
  width:120px;
  height:120px;
  font-size:32px;
  line-height:120px;
  border:1px dashed #e1e1e1;
}
.avatar{
  width:120px;
  height:120px;
}
</style>
